(function(){
    'use strict';
    angular.module('Directives').directive('bbaDriverJobs', bbaDriverJobs); 
    bbaDriverJobs.$inject = [
        'FleetService',
        'toastr',
        '$q',
        '$filter'
    ];

    function bbaDriverJobs(
        FleetService,
        toastr, 
        $q,
        $filter
    ){
        return {
            restrict: 'E', 
            templateUrl: '/templates/directives/components/driver-chat/bbaDriverJobs.html', 
            scope: {
                newMessage: '=',
                driverData: '=', 
                updateNewMsgNotif: '=',
                selectJobCallback: '=',
                removePanelCallback: '='
            }, 
            link: bbaDriverJobsLink
        }

        function bbaDriverJobsLink(scope, elems, attrs) {
            scope.showPanelBody = true; 

            scope.togglePanel = togglePanel; 
            scope.searchJob = searchJob;
            scope.removeJobsPanel = removeJobsPanel;

            

            init();
            function init(){
                addWatchers();
            }

            function addWatchers(){
                scope.$watch('driverData', (driver) => {
                    if(driver != undefined) {
                        scope.driverJobs = [];
                        loadAllJobsData();
                    }
                });

                scope.$watch('newMessage', (msg) => {
                    if(msg != undefined) {
                        loadAllJobsData();
                    }
                });

                scope.$watch('updateNewMsgNotif', (data) => {
                    if(data){
                        console.log(data);
                        scope.driverJobs = addNewMsgIndicator(scope.driverJobs);
                    }
                });
            }

            function removeJobsPanel(){
                scope.removePanelCallback({
                    jobId: 'jobs-list'
                });
            }

            function togglePanel() {
                scope.showPanelBody = !scope.showPanelBody;
            }

            function searchJob(jobId){
                if(jobId != "") {
                    scope.loading = true;
                    loadJobsData({jobId: jobId}).then(data=>{
                        console.log(data);
                        scope.loading = false;
                        scope.driverJobs = data;
                    });
                }
                else {
                    loadAllJobsData();
                }
            }

            function loadAllJobsData(showLoading = true){
                scope.loading = showLoading;
                $q.all({
                    allJobs: loadJobsData(), 
                    jobsWithMsgs: loadJobsThatHasNewMsgs()
                }).then(function(data){
                    scope.loading = false;
                    scope.driverJobs = data.jobsWithMsgs.length != 0 ? $filter('getUniqueValues')(data.jobsWithMsgs.concat(data.allJobs)) : data.allJobs;
                }, error => {
                    console.log(error);
                    scope.loading = false;
                });
            }

            function loadJobsData(filters = {}){
                const deffered = $q.defer(); 
                filters['driver.id'] = scope.driverData.driverId;
                FleetService.Chat.jobs(data => {  
                    const driverJobs = addNewMsgIndicator(data.content).map(job=>{
                        return {
                            id: job.id,
                            type: job.type, 
                            jobId: job.jobId, 
                            driver: scope.driverData.name, 
                            newMsg: job.newMsg
                        }
                    });
                    deffered.resolve(driverJobs);
                }, error => {
                    toastr.error("Unable To Load Jobs", error.message);
                    deffered.reject(error);
                }, angular.extend({
                    size: 10,
                    sort: 'id,asc',
                    jobsStatus: ['INPROGRESS', 'RECEIVED', 'ACCEPTED', 'FAILED']
                }, filters));
                return deffered.promise;
            }

            function loadJobsThatHasNewMsgs(){
                const deffered = $q.defer();
                const storedMsg = JSON.parse(localStorage.getItem('new-messages'));  
                const filters = {};
                if(storedMsg) {
                    const jobIds = storedMsg.map(data => {
                        return data.jobId;
                    });
                    filters.id = jobIds;
                    filters['driver.id'] = scope.driverData.driverId;
                    FleetService.Chat.jobs(data => {  
                        const driverJobs = addNewMsgIndicator(data.content).map(job=>{
                            return {
                                id: job.id,
                                type: job.type, 
                                jobId: job.jobId, 
                                driver: scope.driverData.name, 
                                newMsg: job.newMsg
                            }
                        });
                        deffered.resolve(driverJobs);
                    }, error => {
                        toastr.error("Unable To Load Jobs", error.message);
                        deffered.reject(error);
                    }, angular.extend({
                        size: 10,
                        sort: 'id,asc',
                        jobsStatus: ['INPROGRESS', 'RECEIVED', 'ACCEPTED', 'FAILED']
                    }, filters));
                }
                else {
                    deffered.resolve([]);
                }
                return deffered.promise;
            }

            function addNewMsgIndicator(jobs){
                const storedMsg = JSON.parse(localStorage.getItem('new-messages')); 
                if(storedMsg) {
                    for(let i = 0; i < jobs.length; i++) {
                        jobs[i].newMsg = 0; 
                        for(let x = 0; x < storedMsg.length; x++) {
                            const msg = storedMsg[x];
                            if(msg.jobId == jobs[i].id) {
                                jobs[i].newMsg += 1;
                            }
                        }
                    }
                    return jobs;
                }
                else {
                    for(let i = 0; i < jobs.length; i++) {
                        jobs[i].newMsg = 0;
                    }
                    return jobs;
                }
            }
        }
    }
})();


// WEBPACK FOOTER //
// ./js/directives/component/driver-chat/bbaDriverJobs.js